import React from 'react';
import _ from 'lodash';

import Dropdown from 'ub/components/dropdown/dropdown';
import { actionTargets } from './text-panel-defaults';

export default class UrlTarget extends React.Component {
  constructor(props) {
    super(props);

    this.triggerTargetChange = this.triggerTargetChange.bind(this);
  }

  getSelectedTarget() {
    let selectedTarget = _(actionTargets)
      .filter((action) => action.value === this.props.currentTarget)
      .head();

    if (_.isEmpty(selectedTarget)) {
      selectedTarget = _.first(actionTargets);
    }

    return selectedTarget;
  }

  triggerTargetChange(target) {
    this.props.changeHandler({
      type: 'urlTargetChange',
      value: target
    });
  }

  render() {
    const selectedTarget = this.getSelectedTarget();

    return (
      <Dropdown
        className="url-target-dropdown"
        value={selectedTarget.value}
        label={selectedTarget.label}
        options={actionTargets}
        changeHandler={this.triggerTargetChange}
        disabled={this.props.disabled}
      />
    );
  }
}

UrlTarget.propTypes = {
  disabled: React.PropTypes.bool,
  currentTarget: React.PropTypes.string,
  changeHandler: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/url-target.jsx